import React, { useEffect, useState } from "react";
import Websocket from "react-websocket";

import {
  is_superuser,
  socketurlsuper,
  socketurlbranch,
  branch,
  is_franchise_admin,
  is_franchise_manager,
  is_franchise_staff,
  is_accountant_only,
  socketurlfranchise,
  franchise,
} from "../Functionalities/Config";
import { fetchOrderSnippet } from "./Logics/OrderSnippet";
import {
  currentPageFromLinks,
  totalPagesFromCount,
} from "../Functionalities/pagination";
import DownloadNew from "../Pages/Reports/DownloadNew";

export default function FilterComponent(props) {
  const [data, setData] = useState({
    type: "",
    event: "",
    pending_count: 0,
    pending_data: [],
    notdelivered_count: 0,
    notdelivered_data: [],
    remaining_count: 0,
    restaurant_declined_count: 0,
    restaurant_unattented_count: 0,
    remaining_data: [],
    ongoing_count: 0,
    ongoing_data: [],
    completed_count: 0,
    completed_data: [],
    alert_sound: "",
    scheduled_count: 0,
  });

  const checkNewOrders = (data) => {
    let Orderdata = JSON.parse(data);

    setData({
      ...data,
      type: Orderdata.type ? Orderdata.type : "",
      event: Orderdata.event ? Orderdata.event : "",
      pending_count: Orderdata.pending_count ? Orderdata.pending_count : 0,
      pending_data: Orderdata.pending_data ? Orderdata.pending_data : [],
      notdelivered_count: Orderdata.notdelivered_count
        ? Orderdata.notdelivered_count
        : 0,
      notdelivered_data: Orderdata.notdelivered_data
        ? Orderdata.notdelivered_data
        : [],
      remaining_count: Orderdata.remaining_count
        ? Orderdata.remaining_count
        : 0,
      remaining_data: Orderdata.remaining_data ? Orderdata.remaining_data : [],
      ongoing_count: Orderdata.ongoing_count ? Orderdata.ongoing_count : 0,
      ongoing_data: Orderdata.ongoing_data ? Orderdata.ongoing_data : [],
      completed_count: Orderdata.completed_count
        ? Orderdata.completed_count
        : 0,
      completed_data: Orderdata.completed_data ? Orderdata.completed_data : [],
      alert_sound: Orderdata.alert_sound && Orderdata.alert_sound,
      scheduled_count: Orderdata.scheduled_count ? Orderdata.scheduled_count : 0,
      restaurant_declined_count: Orderdata?.restaurant_declined_count,
      restaurant_unattented_count: Orderdata?.restaurant_unattented_count,
    });
  };

  const unselectAllStatuses = () => {
    sessionStorage.setItem("rejected", false);
    sessionStorage.setItem("unattended", false);
    sessionStorage.setItem("pending", false);
    sessionStorage.setItem("scheduled", false);
  };

  useEffect(() => {
    unselectAllStatuses();

    const pollOrderCounts = async () => {
      try {
        const resData = await fetchOrderSnippet();
        if (!resData) return;

        setData(prev => ({
          ...prev,
          pending_count: resData.pending_count !== undefined ? resData.pending_count : prev.pending_count,
          ongoing_count: resData.ongoing_count !== undefined ? resData.ongoing_count : prev.ongoing_count,
          completed_count: resData.completed_count !== undefined ? resData.completed_count : prev.completed_count,
          remaining_count: resData.pending_count !== undefined ? resData.pending_count : prev.remaining_count,
          scheduled_count: resData.scheduled_count !== undefined ? resData.scheduled_count : prev.scheduled_count,
        }));
      } catch (error) {
        console.error("Error polling order counts:", error);
      }
    };

    if (props.tab === "order") {
      pollOrderCounts();
    }
  }, []);

  const getCurrentPage = () => {
    if (props.currentPage) {
      return props.currentPage;
    }
    return currentPageFromLinks(props.next, props.prev);
  };

  const getTotalPages = (currPage) => {
    if (props.totalPages) {
      return props.totalPages;
    }
    const count =
      typeof props.count === "number"
        ? props.count
        : typeof props.totalCount === "number"
        ? props.totalCount
        : typeof props.OrderCount === "number"
        ? props.OrderCount
        : null;

    if (count !== null && count >= 0) {
      return totalPagesFromCount(count, props.next, props.prev, props.pageSize);
    }

    if (!props.prev && !props.next) {
      return 1;
    }

    if (!props.next && props.prev) {
      return currPage;
    }

    return null;
  };

  const currentPage = getCurrentPage();
  const totalPages = getTotalPages(currentPage);

  return (
    <div
      className={
        props.transactionButtonName ? "card-header p-0" : "card-header "
      }
    >
      {is_accountant_only ? null : is_superuser ? (
        <Websocket
          url={socketurlsuper}
          onMessage={(data) => checkNewOrders(data)}
        />
      ) : is_franchise_admin || is_franchise_manager || is_franchise_staff ? (
        <Websocket
          url={`${socketurlfranchise}${franchise.id}/`}
          onMessage={(data) => checkNewOrders(data)}
        />
      ) : (
        <Websocket
          url={`${socketurlbranch}${branch[0].id}/`}
          onMessage={(data) => checkNewOrders(data)}
        />
      )}
      {(props.tab === "order" || (props.TotalWallet && is_superuser)) && (
        <div
          className={"card-action card-tabs mb-sm-4 mb-3 mr-auto"}
          style={{ flex: "1 1 auto", minWidth: 0 }}
        >
          {props.tab === "order" ? (
            <>
              <ul className="nav nav-tabs" role="tablist">
                <li className="nav-item">
                  <a
                    className="nav-link active"
                    data-toggle="tab"
                    href="#All"
                    role="tab"
                    aria-selected="true"
                    onClick={(e) => {
                      unselectAllStatuses();
                      props.functionFilter("", e);
                    }}
                  >
                    <span>All</span>
                  </a>
                </li>
              <li className="nav-item">
                <a
                  className="nav-link "
                  data-toggle="tab"
                  href="#Pending"
                  role="tab"
                  aria-selected=""
                  onClick={(e) => {
                    sessionStorage.setItem("rejected", false);
                    sessionStorage.setItem("unattended", false);
                    // sessionStorage.setItem("pending", true);
                    props.functionFilter(["1", "2"], e);
                  }}
                >
                  <span>
                    Pending{" "}
                    {data.remaining_count > 0 && (
                      <span
                        style={{
                          fontSize: "12px",
                          color: "red",
                          fontWeight: "bold",
                        }}
                      >
                        ({data.remaining_count})
                      </span>
                    )}
                  </span>
                </a>
              </li>

              {/* restaurant pending */}
              <li className="nav-item">
                <a
                  className="nav-link "
                  data-toggle="tab"
                  href="#Unattended"
                  role="tab"
                  aria-selected=""
                  onClick={(e) => {
                    sessionStorage.setItem("unattended", true);
                    sessionStorage.setItem("rejected", false);
                    sessionStorage.setItem("pending", false);
                    props.functionFilter(["2", "4"], e);
                  }}
                >
                  <span>
                    Unattended
                  </span>
                </a>
              </li>

              {/* restaurant rejected */}
              <li className="nav-item">
                <a
                  className="nav-link "
                  data-toggle="tab"
                  href="#Rejected"
                  role="tab"
                  aria-selected=""
                  onClick={(e) => {
                    sessionStorage.setItem("rejected", true);
                    sessionStorage.setItem("unattended", false);
                    sessionStorage.setItem("pending", false);
                    props.functionFilter(["2", "4"], e);
                  }}
                >
                  <span>
                    Rejected{" "}
                    {data?.restaurant_declined_count > 0 && (
                      <span
                        style={{
                          fontSize: "12px",
                          color: "red",
                          fontWeight: "bold",
                        }}
                      >
                        ({data?.restaurant_declined_count})
                      </span>
                    )}
                  </span>
                </a>
              </li>

              {/* Scheduled Orders Tab */}
              <li className="nav-item">
                <a
                  className="nav-link "
                  data-toggle="tab"
                  href="#Scheduled"
                  role="tab"
                  aria-selected=""
                  onClick={(e) => {
                    unselectAllStatuses();
                    sessionStorage.setItem("scheduled", true);
                    props.functionFilter([], e);
                  }}
                >
                  <span>
                    Scheduled{" "}
                    {data.scheduled_count > 0 && (
                      <span
                        style={{
                          fontSize: "12px",
                          color: "blue",
                          fontWeight: "bold",
                        }}
                      >
                        ({data.scheduled_count})
                      </span>
                    )}
                  </span>
                </a>
              </li>

              <li className="nav-item">
                <a
                  className="nav-link "
                  data-toggle="tab"
                  href="#Ongoing"
                  role="tab"
                  aria-selected=""
                  onClick={(e) => {
                    unselectAllStatuses();
                    props.functionFilter(["4", "5"], e);
                  }}
                >
                  {/* <span >Ongoing {newOrder[0].ongoing_count > 0 && <span style={{ fontSize: '12px', color: 'green', fontWeight: "bold" }} >({newOrder[0].ongoing_count})</span>}</span> */}
                  <span>
                    Ongoing{" "}
                    {data.ongoing_count > 0 && (
                      <span
                        style={{
                          fontSize: "12px",
                          color: "green",
                          fontWeight: "bold",
                        }}
                      >
                        ({data.ongoing_count})
                      </span>
                    )}
                  </span>
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link "
                  data-toggle="tab"
                  href="#Delivered"
                  role="tab"
                  aria-selected=""
                  onClick={(e) => {
                    unselectAllStatuses();
                    props.functionFilter(["3", "6", "7"], e);
                  }}
                >
                  <span>
                    Completed{" "}
                    {data.completed_count > 0 && (
                      <span
                        style={{
                          fontSize: "12px",
                          color: "dark",
                          fontWeight: "bold",
                        }}
                      >
                        ({data.completed_count})
                      </span>
                    )}
                  </span>
                </a>
              </li>
            </ul>
            <small>Showing count from 4 hours before now</small>
            <br />
          </>
        ) : (
          ""
        )}

        {props.TotalWallet && is_superuser && (
          <h5 style={{ marginLeft: 15 }}>
            {props.TotalWallet + ": ₹" + props.TotalWalletAmount}
          </h5>
        )}
      </div>
      )}
      <div
        className={
          props.transactionButtonName
            ? "d-sm-flex ml-auto"
            : "d-sm-flex mb-lg-4 mb-2 ml-auto"
        }
      >
        <div className="text-right d-flex align-items-center flex-wrap justify-content-end">
          {props.changeStatusBtnname && (
            <>
              {(is_superuser ||
                is_franchise_admin ||
                is_franchise_manager ||
                is_franchise_staff) && (
                <div
                  type="submit"
                  data-toggle="modal"
                  data-target="#ReportStatusModal"
                  style={{ marginLeft: 15 }}
                  className="btn btn-primary mb-1 btn-rounded"
                >
                  change Status
                </div>
              )}
            </>
          )}

          {props.columnButtonName && (
            <div
              type="submit"
              data-toggle="modal"
              data-target="#ColumnModal"
              style={{ marginLeft: 15 }}
              className="btn btn-primary mb-1 btn-rounded"
            >
              {props.columnButtonName}
            </div>
          )}

          {props.export && (
            <div
              style={{ marginLeft: 15 }}
              className={"btn btn-primary mb-1 btn-rounded"}
            >
              <DownloadNew
                data={props?.export?.data}
                type={props.type}
                columns={props.export.columns}
                defaultColums={props.export.defaultColums}
              />
            </div>
          )}
          {(props.OrderCount == "-" || props.OrderCount) && (
            <div
              type="submit"
              style={{ marginLeft: 15 }}
              disabled
              className="btn btn-success mb-1 btn-rounded"
            >
              Total : {props?.OrderCount}
            </div>
          )}

          {props.filterButtonName && (
            <div
              type="submit"
              data-toggle="modal"
              data-target="#sendFilterModal"
              style={{ marginLeft: 15 }}
              className="btn btn-primary mb-1 btn-rounded"
              id="timepicker"
            >
              {props.filterButtonName}
            </div>
          )}

          {props.transactionButtonName && (
            <div
              type="submit"
              onClick={props.PrimaryBtnFunc}
              data-toggle="modal"
              data-target="#TransactionHistoryModal"
              style={{ marginLeft: 0 }}
              className="btn btn-primary mb-1 btn-rounded"
              id="timepicker"
            >
              {props.transactionButtonName}
            </div>
          )}
          {props.addItemPath && (
            <div
              style={{ marginLeft: 15 }}
              className="mt-12 btn btn-primary mb-1 btn-rounded"
              id="timepicker"
            >
              <a href={props.addItemPath} style={{ color: "#FFF" }}>
                {props.addItemName}
              </a>
            </div>
          )}
          {props.handlePrev && (
            <div
              style={{
                marginLeft: 15,
                width: "auto",
                minWidth: 70,
                cursor: props.prev != null ? "pointer" : "default",
              }}
              onClick={props.prev && props.handlePrev}
              className={
                props.prev != null
                  ? "d-inline-block form-control date-button btn btn-primary light btn-rounded"
                  : "d-inline-block form-control date-button btn btn-light light btn-rounded"
              }
              id="timepicker"
              disabled={props.prev != null ? false : true}
              placeholder="Prev"
            >
              Prev
            </div>
          )}

          {(props.handlePrev || props.handleNext) && (
            <span
              style={{
                marginLeft: 15,
                marginRight: 0,
                fontWeight: 600,
                fontSize: "14px",
                color: "#6c757d",
                whiteSpace: "nowrap",
                display: "inline-flex",
                alignItems: "center",
                verticalAlign: "middle",
                height: "40px",
                lineHeight: "40px",
                userSelect: "none",
              }}
            >
              Page {currentPage}{totalPages ? ` of ${totalPages}` : ""}
            </span>
          )}

          {props.handleNext && (
            <div
              style={{
                marginLeft: 15,
                width: "auto",
                minWidth: 70,
                cursor: props.next != null ? "pointer" : "default",
              }}
              onClick={props.next && props.handleNext}
              className={
                props.next != null
                  ? "d-inline-block form-control date-button btn btn-primary light btn-rounded"
                  : "d-inline-block form-control date-button btn btn-light light btn-rounded"
              }
              id="timepicker"
              placeholder="Next"
              disabled={props.next}
            >
              Next
            </div>
          )}

          {props.modalButton && (
            <div
              type="submit"
              data-toggle="modal"
              data-target="#sendMessageModal"
              style={{ marginLeft: 15 }}
              className="btn btn-primary mb-1 btn-rounded"
              id="timepicker"
            >
              {props.addItemName}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
